export default __webpack_public_path__ + "static/media/rhinoceros.ebb497e7.png";